import { DialogTypes } from "@/interfaces/component/dialog.interface"
import { useDialogStore } from "@/store/dialog.store"

export function updateAvailableDialogBody(version?: string | null): string {
  if (version) {
    return `Er is een nieuwe versie (${version}) van de app beschikbaar. Vernieuw om de update te installeren.`
  }

  return "Er is een nieuwe versie van de app beschikbaar. Vernieuw om de update te installeren."
}

export function showUpdateAvailableDialog(options: {
  version?: string | null
  skippable?: boolean
  onConfirm: () => void | Promise<void>
  onCancel?: () => void
}): boolean {
  const dialogStore = useDialogStore()
  if (dialogStore.currentDialog) return false

  const skippable = options.skippable !== false

  dialogStore.currentDialog = {
    type: skippable ? DialogTypes.CONFIRM : DialogTypes.OK,
    title: "Update beschikbaar",
    body: updateAvailableDialogBody(options.version),
    textConfirm: "Vernieuwen",
    textCancel: skippable ? "Later" : undefined,
    lock: !skippable,
    onConfirm: async () => {
      dialogStore.currentDialog = null
      await options.onConfirm()
    },
    onCancel: skippable
      ? () => {
          dialogStore.currentDialog = null
          options.onCancel?.()
        }
      : undefined
  }

  return true
}
